import { getCookie } from "./cookie";

const memberKey = "ISDVCMEMBER";

const validateUserTypeContent = (
	item,
	userType,
	content,
	key,
	filterContent
) => {
	if (item && item.targetAudience && !item.targetAudience.includes(userType)) {
		delete content[key];
	} else {
		filterContent(item);
	}
};

export const filterContentByUserType = (originalContent, filterTypes, user) => {
	const contentToProcess = JSON.parse(JSON.stringify(originalContent));
	let userType = "";
	if (user?.swid) {
		userType = filterTypes[user.membership ? "memberLoggedIn" : "loggedIn"];
	} else {
		userType =
			getCookie(memberKey) === "1"
				? filterTypes["memberLoggedOut"]
				: filterTypes["loggedOut"];
	}
	const filterContent = (content) => {
		for (const key in content) {
			const item = content[key];
			if (typeof item === "object") {
				validateUserTypeContent(item, userType, content, key, filterContent);
				if (Array.isArray(item)) {
					if (Object.keys(item).length === 0) {
						content[key] = [];
					} else {
						content[key] = item.filter((element) => element);
					}
				}
			}
		}
	};
	filterContent(contentToProcess);
	return contentToProcess;
};

/**
 * Recursively filters items from a content tree based on a predicate.
 * Uses the same traversal pattern as filterContentByUserType.
 * @param {any} content - The content structure to filter (sections array, object, etc.)
 * @param {Function} shouldRemove - Predicate that receives an item and returns true if it should be removed.
 * @returns {any} A deep copy of the content with matching items removed.
 */
export const filterContentByPredicate = (content, shouldRemove) => {
	if (!content) return content;
	const contentToProcess = JSON.parse(JSON.stringify(content));
	const filterRecursive = (obj) => {
		for (const key in obj) {
			const item = obj[key];
			if (typeof item === "object") {
				if (shouldRemove(item)) {
					delete obj[key];
				} else {
					filterRecursive(item);
				}
				if (Array.isArray(item)) {
					obj[key] = item.filter((el) => el);
				}
			}
		}
	};
	filterRecursive(contentToProcess);
	return contentToProcess;
};
